import { createSlice } from '@reduxjs/toolkit';

const notification = createSlice({
    name: 'notification',
    initialState: {
        isError: false,
        errorText: '',
        isErrorAfter401: false,
        isSuccess: false,
        successText: '',
        successNavigation: '/',
        successButtonName: null
    },
    reducers: {
        setIsError(state, action) {
            state.isError = !!action.payload;
            state.errorText = action.payload;
        },
        setIsErrorAfter401(state, action) {
            state.isErrorAfter401 = action.payload;
        },
        setIsSuccess(state, action) {
            state.isSuccess = !state.isSuccess;
            state.successText = action.payload.successText;
            state.successNavigation = action.payload.successNavigation;
            state.successButtonName = action.payload.successButtonName;
        }
    }
});

export default notification.reducer;
export const { setIsError, setIsErrorAfter401, setIsSuccess } = notification.actions;
